import { render } from "./NftNtfcView.vue?vue&type=template&id=255dec1a&ts=true"
import script from "./NftNtfcView.vue?vue&type=script&lang=ts"
export * from "./NftNtfcView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__